import { SearchDocumentType } from '@wix/client-search-sdk';
import { CategoryList } from '@wix/search-settings-client';
import { Experiments } from '@wix/yoshi-flow-editor';

import { Spec } from './specs';

export const getVisibleDocumentTypes = (
  availableDocumentTypes: SearchDocumentType[],
  categoryListSettings: CategoryList,
  experiments: Experiments,
): SearchDocumentType[] => {
  return availableDocumentTypes
    .filter((documentType) => categoryListSettings[documentType].visible)
    .filter(
      (documentType) =>
        !(
          experiments.enabled(Spec.AllTabDisabled) &&
          documentType === SearchDocumentType.All
        ),
    )
    .sort(
      (documentTypeA, documentTypeB) =>
        categoryListSettings[documentTypeA].index -
        categoryListSettings[documentTypeB].index,
    );
};
